import {Pipe, PipeTransform} from '@angular/core';

@Pipe ({
   name : 'appVersion'
})

export class AppVersionPipe implements PipeTransform {
   transform(val : string) : string {
        let retVal: string;

        if(val.match("^(Word|Excel|PowerPoint|Outlook)(19)?$")){
            let iIndex = val.lastIndexOf("1");
            if(iIndex > 0){
                retVal = val.substring(0,iIndex) + " 2019";
            }else{
                retVal = val + " 2016";
            }
        }
        else{
            retVal = val;
        }
        return retVal;
   }
}


// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/pipes/app-version.pipe.ts